"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _primitives = _interopRequireDefault(require("../../primitives"));

var _excluded = ["children"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var propTypes = {
  /** Suggestion content */
  children: _propTypes.node
};
/**
 * Basic styles for item shown in search suggested terms. Accepts <Box> style
 * props. Usually wrapped in link or passed onClick handler.
 */

var SearchSuggestion = function SearchSuggestion(_ref) {
  var children = _ref.children,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  return /*#__PURE__*/_react["default"].createElement(_primitives["default"].Box, _extends({
    px: 2,
    py: 1
  }, props), /*#__PURE__*/_react["default"].createElement(_primitives["default"].Text, {
    color: "coolgray",
    fontSize: 2
  }, children));
};

SearchSuggestion.propTypes = propTypes;
var _default = SearchSuggestion;
exports["default"] = _default;